module.exports = __webpack_public_path__ + "assets/img/LTC037.86d870d8.png";